'use es6';

import * as React from 'react';
import { isReactVersionAtLeast } from "./reactVersion.js";

/**
 * Extracts the `ref` from a React element, handling different React versions.
 */
export function getReactElementRef(element) {
  var _ref;
  if (! /*#__PURE__*/React.isValidElement(element)) {
    return null;
  }
  const reactElement = element;
  const propsWithRef = reactElement.props;
  return (_ref = isReactVersionAtLeast(19) ? propsWithRef === null || propsWithRef === void 0 ? void 0 : propsWithRef.ref : reactElement.ref) !== null && _ref !== void 0 ? _ref : null;
}